import { callApi } from './ApiClient';

const getLetterPlans = (dispatch) => {
  return callApi('GET', '/letter-plans', null, dispatch);
}

export const PlansApi = {
  getLetterPlans,
};



// WEBPACK FOOTER //
// ./src/redux/api/PlansApi.js